module.exports = __webpack_public_path__ + "img/ICT.cb9d2f6f.svg";